(() => {
  if (window.__imperialSocialLeadBound) return;
  window.__imperialSocialLeadBound = true;
  const storageKey = 'it_social_attribution_v1';
  const sessionKey = 'it_social_session_v1';
  const eventKey = 'it_social_events_v1';
  const socialHosts = ['instagram.com', 'facebook.com', 'fb.com', 'tiktok.com', 'pinterest.', 'twitter.com', 'x.com', 'linktr.ee'];
  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
  const params = new URLSearchParams(window.location.search);
  const safeParse = (value, fallback) => {
    if (value == null || value === '') return fallback;
    try {
      const parsed = JSON.parse(value);
      return parsed == null ? fallback : parsed;
    } catch (error) {
      return fallback;
    }
  };
  const allowed = purpose => {
    try { return window.Shopify?.customerPrivacy?.[purpose === 'marketing' ? 'marketingAllowed' : 'analyticsProcessingAllowed']?.() === true; } catch (_) { return false; }
  };
  const storageAllowed = storage => allowed(storage === localStorage ? 'marketing' : 'analytics');
  const storageGet = (storage, key) => {
    if (!storageAllowed(storage)) return null;
    try { return storage.getItem(key); } catch (error) { return null; }
  };
  const storageSet = (storage, key, value) => {
    if (!storageAllowed(storage)) return;
    try { storage.setItem(key, value); } catch (error) {}
  };
  const storageRemove = (storage, key) => {
    try { storage.removeItem(key); } catch (error) {}
  };
  const clean = (value) => String(value || '').trim().slice(0, 180);
  const getSessionId = () => {
    let id = storageGet(sessionStorage, sessionKey);
    if (!id) {
      id = window.crypto && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      storageSet(sessionStorage, sessionKey, id);
    }
    return id;
  };
  const currentTouch = () => {
    const touch = {};
    attributionKeys.forEach((key) => {
      if (params.has(key)) touch[key] = clean(params.get(key));
    });
    touch.landing_path = clean(window.location.pathname);
    touch.referrer = clean(document.referrer);
    touch.captured_at = new Date().toISOString();
    return touch;
  };
  const isSocialTouch = (touch) => {
    const medium = clean(touch.utm_medium).toLowerCase();
    const source = clean(touch.utm_source).toLowerCase();
    const referrer = clean(touch.referrer).toLowerCase();
    return medium.includes('social') || socialHosts.some((host) => source.includes(host.split('.')[0]) || referrer.includes(host));
  };
  const incoming = currentTouch();
  let attribution = {}, activeTouch = {}, pageIsAttributed = false;
  const refreshAttribution = () => {
    if (!allowed('marketing')) {
      attribution = {}; activeTouch = {}; pageIsAttributed = false;
      storageRemove(localStorage, storageKey);
    } else {
      attribution = safeParse(storageGet(localStorage, storageKey), {});
      if (!attribution || typeof attribution !== 'object' || Array.isArray(attribution)) attribution = {};
      if (isSocialTouch(incoming) || incoming.fbclid) {
        attribution = { first: attribution.first || incoming, last: incoming, expires_at: Date.now() + 90 * 24 * 60 * 60 * 1000 };
        storageSet(localStorage, storageKey, JSON.stringify(attribution));
      } else if (attribution.expires_at && attribution.expires_at < Date.now()) {
        attribution = {}; storageRemove(localStorage, storageKey);
      }
      activeTouch = attribution.last || (isSocialTouch(incoming) ? incoming : {});
      pageIsAttributed = Boolean(activeTouch.utm_source || activeTouch.utm_medium || activeTouch.utm_campaign || activeTouch.referrer);
    }
    if (!allowed('analytics')) {
      storageRemove(sessionStorage, sessionKey); storageRemove(sessionStorage, eventKey);
    }
  };
  refreshAttribution();
  document.addEventListener('imperial:privacy-ready', refreshAttribution);
  document.addEventListener('visitorConsentCollected', refreshAttribution);
  const basePayload = () => ({
    session_id: getSessionId(),
    page_path: clean(window.location.pathname),
    page_title: clean(document.title),
    template: clean(document.body.dataset.template),
    template_suffix: clean(document.body.dataset.templateSuffix),
    product_id: clean(document.body.dataset.productId),
    product_type: clean(document.body.dataset.productType),
    utm_source: clean(activeTouch.utm_source),
    utm_medium: clean(activeTouch.utm_medium),
    utm_campaign: clean(activeTouch.utm_campaign),
    utm_content: clean(activeTouch.utm_content),
    first_landing_path: clean(attribution.first && attribution.first.landing_path)
  });
  const emit = (name, detail = {}) => {
    if (!allowed('analytics')) return;
    const payload = Object.assign({ event: name, event_time: new Date().toISOString() }, basePayload(), detail);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish(name, payload); } catch (error) {}
    }
    document.dispatchEvent(new CustomEvent('imperial:lead', { detail: payload }));
    const ledger = safeParse(storageGet(sessionStorage, eventKey), []);
    ledger.push(payload);
    storageSet(sessionStorage, eventKey, JSON.stringify(ledger.slice(-30)));
  };
  window.imperialCommerceEvent = (name, detail = {}) => emit(name, detail);
  const classify = (element) => {
    const href = clean(element.getAttribute('href')).toLowerCase();
    if (element.dataset.leadDestination) return element.dataset.leadDestination;
    if (href.includes('wa.me') || href.includes('whatsapp')) return 'whatsapp';
    if (href.startsWith('tel:')) return 'phone';
    if (href.startsWith('mailto:')) return 'email';
    if (href.includes('book.imperialtime.co.uk')) return 'appointment';
    if (href.includes('/pages/sell')) return 'sell';
    if (href.includes('/pages/repair')) return 'repair';
    if (href.includes('/products/')) return 'product';
    if (href.includes('/collections/')) return 'collection';
    if (element.matches('[data-it-cro-override-open]')) return 'make_offer';
    if (element.matches('[name="checkout"]') || href.includes('/checkout')) return 'checkout';
    return '';
  };
  const attributionParams = () => {
    const carried = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term'].forEach((key) => {
      if (activeTouch[key]) carried[key] = activeTouch[key];
    });
    return carried;
  };
  const decorateLinks = () => {
    if (!allowed('marketing')) return;
    if (!activeTouch.utm_source && !activeTouch.utm_medium && !activeTouch.utm_campaign) return;
    document.querySelectorAll('a[href][data-lead-destination], [data-social-hub] a[href]').forEach((link) => {
      const raw = link.getAttribute('href');
      if (!raw || raw.startsWith('#') || raw.startsWith('tel:') || raw.startsWith('mailto:') || raw.includes('wa.me')) return;
      try {
        const url = new URL(raw, window.location.origin);
        if (url.origin !== window.location.origin && url.hostname !== 'book.imperialtime.co.uk') return;
        Object.entries(attributionParams()).forEach(([key, value]) => url.searchParams.set(key, value));
        if (link.dataset.leadContent) url.searchParams.set('utm_content', clean(link.dataset.leadContent));
        link.href = url.toString();
      } catch (error) {}
    });
  };
  const onSocialHub = Boolean(document.querySelector('[data-social-hub]'));
  const trackingContext = () => onSocialHub || pageIsAttributed;
  document.addEventListener('click', (event) => {
    const element = event.target.closest('a,button');
    if (!element) return;
    const destination = classify(element);
    const explicitEvent = clean(element.dataset.leadEvent);
    if (trackingContext() && (explicitEvent || destination)) emit(explicitEvent || 'lead_cta_click', { lead_type: destination, cta_text: clean(element.textContent), destination_url: clean(element.getAttribute('href')), content_id: clean(element.dataset.leadContent || element.dataset.watchAction || element.dataset.repairEvent) });
    if (destination === 'checkout') emit('imperial_checkout_click', { checkout_surface: element.closest('cart-drawer') ? 'cart_drawer' : (document.body.dataset.template === 'cart' ? 'cart_page' : 'other') });
    if (destination === 'checkout' && pageIsAttributed) emit('begin_checkout_from_social');
  }, true);
  document.addEventListener('focusin', (event) => {
    const form = event.target.closest('form');
    if (!form || form.dataset.leadStarted) return;
    if (trackingContext() && form.matches('[data-lead-form], .social-lead-form, form[action*="contact"]')) {
      form.dataset.leadStarted = 'true';
      emit('lead_form_start', { form_name: clean(form.dataset.leadForm || form.id || 'contact') });
    }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = clean(form.getAttribute('action'));
    if (trackingContext() && form.matches('[data-lead-form], .social-lead-form, form[action*="contact"]')) emit('lead_form_submit', { form_name: clean(form.dataset.leadForm || form.id || 'contact') });
    if (pageIsAttributed && action.includes('/cart/add')) emit('add_to_cart_from_social');
  }, true);
  if (document.querySelector('[data-contact-success]') || params.get('contact_posted') === 'true') emit('lead_form_success');
  if (onSocialHub) emit('social_hub_view');
  if (pageIsAttributed && !onSocialHub) emit('social_destination_view');
  if (pageIsAttributed && document.body.dataset.template === 'product') emit('view_product_from_social');
  let qualified = false;
  const qualify = (reason) => {
    if (qualified || !trackingContext()) return;
    qualified = true;
    emit('social_qualified_visit', { qualification: reason });
  };
  window.setTimeout(() => qualify('30_seconds'), 30000);
  window.addEventListener('scroll', () => {
    const denominator = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    if (window.scrollY / denominator >= 0.5) qualify('50_percent_scroll');
  }, { passive: true });
  decorateLinks();
})();

(() => {
  if (!window.matchMedia) return;
  if (window.__imperialEngagementVideoBound) return;
  window.__imperialEngagementVideoBound = true;
  const webmUrl = 'https://cdn.shopify.com/videos/c/o/v/b41d91e74e0844a3aa0f39667121fba5.webm';
  const mp4Url = 'https://cdn.shopify.com/videos/c/o/v/7cdddfc2a8ba442da3f1469d2130ee70.mp4';
  const posterUrl = 'https://cdn.shopify.com/s/files/1/0952/5562/6071/files/imperial-time-engagement-poster.webp?v=1789305774';
  const motionQuery = window.matchMedia('(min-width: 992px) and (prefers-reduced-motion: no-preference)');

  const getMedia = () => {
    const link = document.querySelector('.imperial-engagement-media-link');
    return link && link.closest('.image-with-text__media');
  };

  const disableVideo = () => {
    document.querySelectorAll('.imperial-engagement-video').forEach((video) => {
      video.pause();
      video.removeAttribute('src');
      video.load();
      video.remove();
    });
  };

  const enableVideo = () => {
    if (!motionQuery.matches) return;
    const media = getMedia();
    if (!media || media.querySelector('.imperial-engagement-video')) return;

    const video = document.createElement('video');
    const supportsWebm = video.canPlayType('video/webm; codecs="vp9"');
    video.className = 'imperial-engagement-video';
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'none';
    video.poster = posterUrl;
    video.setAttribute('muted', '');
    video.setAttribute('aria-hidden', 'true');
    video.tabIndex = -1;
    Object.assign(video.style, {
      position: 'absolute',
      inset: '0',
      zIndex: '1',
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    });

    video.src = supportsWebm ? webmUrl : mp4Url;
    media.insertBefore(video, media.querySelector('.imperial-engagement-media-link'));
    video.load();
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
  };

  const syncVideo = () => {
    if (motionQuery.matches) enableVideo();
    else disableVideo();
  };

  const init = () => {
    syncVideo();
    if (typeof motionQuery.addEventListener === 'function') motionQuery.addEventListener('change', syncVideo);
    else if (typeof motionQuery.addListener === 'function') motionQuery.addListener(syncVideo);
    document.addEventListener('shopify:section:load', syncVideo);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
